import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IntegrationImport } from 'models';
import { IntegrationStayExclusion, IntegrationStayExclusionRestoreResult } from './stay-exclusion';

@Injectable({
	providedIn: 'root',
})
export class IntegrationImportService {
	constructor(private http: HttpClient) {}

	public getListingImports(userId: string): Observable<IntegrationImport[]> {
		return this.http.get<IntegrationImport[]>(`api/integrations/listingimport/get/${userId}`);
	}

	public getStayImports(userId: string): Observable<IntegrationImport[]> {
		return this.http.get<IntegrationImport[]>(`api/integrations/stayimport/get/${userId}`);
	}

	public getIntegrationDisplayName(userId: string): Observable<string> {
		return this.http.get<string>(`api/integrations/displayName/${userId}`);
	}

	public getStayExclusions(userId: string): Observable<IntegrationStayExclusion[]> {
		return this.http.get<IntegrationStayExclusion[]>(`api/integrations/stayexclusion/get/${userId}`);
	}

	public restoreStayExclusion(stayExclusionId: number): Observable<IntegrationStayExclusionRestoreResult> {
		return this.http.post<IntegrationStayExclusionRestoreResult>(`api/integrations/stayexclusion/restore/${stayExclusionId}`, {});
	}
}
